import { v1ApiClient } from '@/services';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

export const getChartList = async (): Promise<ChartItem[]> => {
  const wa = getCurrWorkspaceAlias();
  const res = await v1ApiClient.get(`/workspaces/${wa}/charts`);
  return res.data;
};
